import {
  Directive,
  HostListener,
  ElementRef,
  Renderer2,
  AfterViewInit
} from '@angular/core';

@Directive({
  selector: '[megaStoreAdminPhoneNoLength]'
})
export class PhoneNoLengthDirective implements AfterViewInit {
  private inputElement!: HTMLInputElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    // Find the input element within the ngx-mat-intl-tel-input component
    this.inputElement = this.el.nativeElement.querySelector('input');

    if (this.inputElement) {
      this.renderer.listen(this.inputElement, 'input', event => this.onInputChange(event)
      );
    }
  }

  onInputChange(event: Event): void {
    let value = this.inputElement.value;

    // Remove all non-digit characters
    value = value.replace(/\D/g, '');

    // Limit to 15 digits
    if (value.length > 15) {
      value = value.substring(0, 15);
    }

    this.inputElement.value = value;
    if (event instanceof InputEvent) {
      event.preventDefault();
    }
  }
}
